export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export function lightOrDark(color) {
	var element, bgColor, brightness, r, g, b, hsp;

	// Check the format of the color, HEX or RGB?
	if (color.match(/^rgb/)) {
	  // If HEX --> store the red, green, blue values in separate variables
	  color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
	  r = color[1];
	  g = color[2];
	  b = color[3];
	} else {

	  // If RGB --> Convert it to HEX: http://gist.github.com/983661
	  color = +("0x" + color.slice(1).replace(
		color.length < 5 && /./g, '$&$&'
	  ));
	  r = color >> 16;
	  g = color >> 8 & 255;
	  b = color & 255;
	}
	// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
	hsp = Math.sqrt(
	  0.299 * (r * r) +
	  0.587 * (g * g) +
	  0.114 * (b * b)
	);

	// Using the HSP value, determine whether the color is light or dark
	if (hsp>127.5) {
	  return 'light';
	}
	else {
	  return 'dark';
	}
}


// Lerp
export function lerp(a, b, n) {
	return (1 - n) * a + n * b;
}

// Map number x from range [a, b] to [c, d]
export function map(x, a, b, c, d) {
	return ((x - a) * (d - c)) / (b - a) + c;
}

// Select Matching Video Source
export function selectMatchingVideoSource(video) {
	return new Promise((resolve) => {
		if(!video) {
			return;
		}
		const rect = video.getBoundingClientRect();

		const clientWidth = rect.width * window.devicePixelRatio;
		const clientHeight = rect.height * window.devicePixelRatio;
		const clientRatio = clientWidth/clientHeight;

		const videoWidth = video.getAttribute('width');
		const videoHeight = video.getAttribute('height');
		const videoRatio = videoWidth/videoHeight;

		let width = '';
		if(clientRatio>videoRatio) {
			width = clientWidth;
		} else {
			width = clientHeight*videoRatio;
		}

		let matchedSource = null;
		let prevDiff = 999999;

		// Loop over all video sources
		const totalSourceCount = video.children.length;
		let checkedSourcesCount = 0;
		const checkSources = new Promise((resolve, reject) => {
			Array.from(video.children).forEach(source => {
				// Get source resolution (provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= prevDiff) {
					matchedSource = source;
				}
				prevDiff = currentDiff;

				setTimeout(() => {
					checkedSourcesCount++;
					if (checkedSourcesCount >= totalSourceCount) {
						resolve('Checked All Sources');
					}
				}, 0);
			});
		});

		checkSources.then(() => {
			if(!matchedSource) {
				return;
			}

			if(video.src!=matchedSource.src) {
				video.pause();
				video.src = matchedSource.src;
				resolve();
			}
		});

	});
}
